var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FieldText, FlexBox, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import * as React from 'react';
import isURL from 'validator/lib/isURL';
import styles from './linkMenu.module.scss';
/**
 * Renders the menu that appears when the link button is pressed. Allows a link
 * to be added/edited or removed.
 */
export function LinkMenu(_a) {
    var { className, initialText, initialUrl, onHide, onAddLink, onUnlink } = _a, otherProps = __rest(_a, ["className", "initialText", "initialUrl", "onHide", "onAddLink", "onUnlink"]);
    const [textValue, setTextValue] = useState(initialText);
    const [urlValue, setUrlValue] = useState(initialUrl);
    const [textTouched, setTextTouched] = useState(false);
    const [urlTouched, setUrlTouched] = useState(false);
    useEffect(() => {
        setTextValue(initialText);
        setUrlValue(initialUrl);
    }, [initialText, initialUrl]);
    const reset = () => {
        setTextValue('');
        setUrlValue('');
        setTextTouched(false);
        setUrlTouched(false);
    };
    const handleAddLink = (e) => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        onAddLink(urlValue, textValue);
        onHide();
        reset();
    };
    const handleUnlink = (e) => {
        e.preventDefault();
        onUnlink();
        onHide();
        reset();
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && isUrlValid && handleAddLink) {
            e.preventDefault();
            handleAddLink();
        }
    };
    const rootClass = classnames({ [styles.root]: true }, className);
    const isUrlValid = isURL(urlValue, { require_protocol: true });
    const hasText = textValue.trim().length > 0;
    return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [_jsx(Text.Heading, Object.assign({ withMarginBottom: true }, { children: "Edit Link" })), _jsx(FieldText, { autoFocus: !hasText, label: "Link title", className: styles.field, onKeyDown: handleKeyDown, meta: {
                    error: textTouched && !hasText ? 'Please enter a title' : undefined,
                }, input: {
                    value: textValue,
                    name: 'pleasedontautofillthis',
                    onBlur: () => setTextTouched(true),
                    onChange: (e) => setTextValue((e === null || e === void 0 ? void 0 : e.target.value) || ''),
                } }), _jsx(FieldText, { autoFocus: hasText, label: "Link URL", className: styles.field, onKeyDown: handleKeyDown, meta: {
                    error: urlTouched && !isUrlValid ? 'Please enter a valid url' : undefined,
                }, input: {
                    value: urlValue,
                    name: 'link_url',
                    onBlur: () => setUrlTouched(true),
                    onChange: (e) => setUrlValue((e === null || e === void 0 ? void 0 : e.target.value) || ''),
                } }), _jsxs(FlexBox, Object.assign({ justifyContent: "space-between" }, { children: [initialUrl ? (_jsx(Button, Object.assign({ variant: "tertiary", onClick: handleUnlink }, { children: "Remove link" }))) : (_jsx("span", {})), _jsx(Button, Object.assign({ disabled: !isUrlValid || !hasText, onClick: handleAddLink }, { children: "Save" }))] }))] })));
}
